<template>
  <!-- 支持渲染多级 menu 菜单 -->
  <el-sub-menu
    v-if="hasVisibleChildren"
    :index="route.path"
    :popper-class="'sidebar-submenu-popper'"
  >
    <template #title>
      <menu-item
        :title="route.meta?.title || ''"
        :icon="route.meta?.icon || 'link'"
      ></menu-item>
    </template>
    <!-- 循环渲染有 meta.title 的子路由 -->
    <sidebar-item
      v-for="item in visibleChildren"
      :key="item.path"
      :route="item"
    ></sidebar-item>
  </el-sub-menu>
  <!-- 渲染 item 项 - 只渲染有 meta.title 的 -->
  <el-menu-item
    v-else-if="route.meta && route.meta.title"
    :index="route.path"
  >
    <menu-item
      :title="route.meta.title"
      :icon="route.meta.icon || 'link'"
    ></menu-item>
  </el-menu-item>
</template>

<script setup>
import MenuItem from './MenuItem'
import { computed, defineProps } from 'vue'

// 定义 props
const props = defineProps({
  route: {
    type: Object,
    required: true
  }
})

// 计算可见的子路由（只有包含 meta.title 的）
const visibleChildren = computed(() => {
  if (!props.route.children) return []
  return props.route.children.filter(
    (child) => child.meta && child.meta.title
  )
})

// 判断是否有可见的子路由
const hasVisibleChildren = computed(() => {
  return visibleChildren.value.length > 0
})
</script>

<style lang="scss" scoped></style>
